import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Row, Col, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import awardeestore from '../../stores/awardeestore';

@observer
export default class UploadVoucherConfirmation extends Component {

  redirectToHome = () => {
    this.props.history.push("/");
    window.location.reload();
  }

  render() {
    const { confirmationId } = awardeestore;

    return (
      <div className='border-form'>
        <>
          <Row className='custom-box'>
            <Col>
              <div className='center-text'>
                <i className='icon icon-ok-circle check-icon' />
              </div>
              <div className='spacer' />
              <div className='center-text poppinsH5-Confirmation'>
                <b>Confirmation: {confirmationId} </b>
              </div>
              <div className='spacer' />
              <h5 className='center-text confirmationTitle poppinsH5-ThankYouNote mt-20'>
                Your documents have been successfully submitted. If you have questions pleas
                email us at <br /><a className='upload_voucher_link' href='mailto:AHAH@wellpoint.com'>AHAH@wellpoint.com</a>&nbsp;
                or call 1-844-451-2828.
              </h5>
            </Col>
          </Row>
          <Row>
            <Col className='flexJustifyAround'>
              <Button color='primary' style={{alignItems: 'center'}} className='btn btn-primary awardeeNextBtn mt-40' onClick={this.redirectToHome}>
                Submit Awardee Profile or Additional Documents
              </Button>
            </Col>
          </Row>
        </>
      </div>
    );
  }
}

UploadVoucherConfirmation.propTypes = {
  history: PropTypes.object
};